import React, { useState, useEffect } from "react";

const chatDB = global.rootRequire('classes/indexedDB').default
const { updateUserProfile, clearIndexedDB } = global.rootRequire('classes/chat')

let lastactive = Math.floor(Date.now() / 1000)

const isElectron = () => {
  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
    return true
  }
  
  if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
    return true
  }
  
  if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
    return true
  }

  return false
}

const Clock = () => {
  useEffect(() => {
    setInterval(() => {
      if (!isElectron()) {
        if (document.hidden) {
          window.location.reload(false)
        }  
      }
    }, 3600000)
    
    setInterval(() => {
      if (!isElectron()) {
        let elem = document.getElementById('chat-root')
        if (elem && document.hidden) {
          elem.dispatchEvent(new CustomEvent('reloadPage', { detail: {reload: true} }))
        }
      } else {}

    }, 600000)

    setInterval(() => {
      let timenow = Math.floor(Date.now() / 1000)
      
      if ((timenow - lastactive) > 7) {
        let elem = document.getElementById('chat-root')
        if (elem && document.hidden) {
          elem.dispatchEvent(new CustomEvent('reloadPage', { detail: {reload: true} }))
        }
      }
      
      lastactive = timenow
    }, 5000)

    setInterval(() => {
      clearIndexedDB()
      // updateUserProfile()
    }, 21600000)

  }, [])

  return <div></div>
};


 

export default Clock